import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import useResolver from '../hooks/useResolver';
import PersonStore from '../store/PersonStore';
import InvitationStore from '../store/InvitationStore';
import OrganizationPersonList, {
  OrganizationPersonListProps,
} from '../components/OrganizationPersonList';
import OrganizationStore from '../store/OrganizationStore';
import ParticipationStore from '../store/ParticipationStore';

export interface ConnectedOrganizationPersonListProps
  extends Partial<Pick<OrganizationPersonListProps, 'compact' | 'title'>> {
  organizationId?: string;
}

const ConnectedOrganizationPersonList: React.FC<
  ConnectedOrganizationPersonListProps
> = ({ organizationId: suppliedOrganizationId, ...props }) => {
  const organizationStore = useResolver(OrganizationStore);
  const personStore = useResolver(PersonStore);
  const invitationStore = useResolver(InvitationStore);
  const currentPerson = personStore.currentPerson;
  const organizationId =
    suppliedOrganizationId || organizationStore.currentOrganizationId;
  const participationStore = useResolver(ParticipationStore);

  useEffect(() => {
    personStore.loadByOrganization(organizationId);
    invitationStore.loadByOrganization(organizationId);

    // Load for parent org - a bit messy, I know
    participationStore.loadByOrganization(
      organizationStore.currentOrganizationId,
      {
        withProject: true,
      },
    );
  }, [personStore, invitationStore, organizationId]);

  return (
    <OrganizationPersonList
      {...props}
      persons={personStore.getFilteredItems({ organizationId })}
      currentPerson={currentPerson}
      editable={currentPerson.hasEditPermission()}
      getPersonInvitation={(personId) =>
        invitationStore.getLatestPersonInvitation(personId)
      }
      createInvitationForPerson={(personId) =>
        invitationStore.createForPerson(personId)
      }
      organizationId={organizationId}
      participations={participationStore.items}
    />
  );
};

export default observer(ConnectedOrganizationPersonList);
